import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCard } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';

import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { ApplicantPqqSectionsComponent } from '../applicant-pqq-sections.component';
import { MessagesEnum } from '@/app/enums/message.enum';
import { MaxLength } from '@/app/enums/max-length.enum';
import { ValidationPatterns } from '@/app/enums/patterns.enum';
@Component({
  standalone: true,
  imports: [
    MatExpansionModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCard,
    MatRadioModule,
  ],
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.css'],
})
export class ReferencesComponent implements OnInit, OnChanges {
  @Input() applicantData: any;
  @Input() isEdit: boolean;
  message = MessagesEnum;
  maxLength = MaxLength;
  validationPatterns = ValidationPatterns;

  formGroup: FormGroup;
  @Input() isFetchApplicantData: boolean;

  constructor(
    private fb: FormBuilder,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router,
    private ApplicantPqqSectionsComponent: ApplicantPqqSectionsComponent
  ) {}
  ngOnInit(): void {
    const isEdit = localStorage.getItem('isEdit');

    const projectId = localStorage.getItem('projectId');

    if (isEdit === 'true' && projectId) {
      // this.getPqqData();
    }

    this.formGroup = this.fb.group({
      // Refrences
      ref_1_client_name: [''],
      ref_1_project_title: [''],
      ref_1_contact_person: [''],
      ref_1_email: [''],
      ref_1_phone: [
        '',
        [Validators.pattern(this.validationPatterns.PhoneNumber)],
      ],

      ref_2_client_name: [''],
      ref_2_project_title: [''],
      ref_2_contact_person: [''],
      ref_2_email: [''],
      ref_2_phone: [
        '',
        [Validators.pattern(this.validationPatterns.PhoneNumber)],
      ],
    });

    // If it's an edit scenario and applicantData exists, populate the form
    if (this.isEdit && this.applicantData) {
      this.patchFormValues();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isFetchApplicantData'] &&
      !changes['isFetchApplicantData'].firstChange
    ) {
      this.patchFormValues();
    }
  }

  patchFormValues() {
    this.formGroup.patchValue({
      ref_1_client_name: this.applicantData?.references
        ? this.applicantData?.references[0]?.client_name
        : '',
      ref_1_project_title: this.applicantData?.references
        ? this.applicantData?.references[0]?.project_title
        : '',
      ref_1_contact_person: this.applicantData?.references
        ? this.applicantData?.references[0]?.contact_person
        : '',
      ref_1_email: this.applicantData?.references
        ? this.applicantData?.references[0]?.email
        : '',
      ref_1_phone: this.applicantData?.references
        ? this.applicantData?.references[0]?.phone
        : '',

      ref_2_client_name: this.applicantData?.references
        ? this.applicantData?.references[1]?.client_name
        : '',
      ref_2_project_title: this.applicantData?.references
        ? this.applicantData?.references[1]?.project_title
        : '',
      ref_2_contact_person: this.applicantData?.references
        ? this.applicantData?.references[1]?.contact_person
        : '',
      ref_2_email: this.applicantData?.references
        ? this.applicantData?.references[1]?.email
        : '',
      ref_2_phone: this.applicantData?.references
        ? this.applicantData?.references[1]?.phone
        : '',
    });
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    const charCode = event.key;
    if (!/[0-9]/.test(charCode) && !allowedKeys.includes(charCode)) {
      event.preventDefault();
    }
  }

  handleBack() {
    this.ApplicantPqqSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    const dataToSubmit = new FormData();
    const references: any[] = [];

    // Loop through the controls and group data into references array
    Object.keys(this.formGroup.controls).forEach((key) => {
      const value = this.formGroup.get(key)?.value;
      if (value !== null && value !== undefined && value !== '') {
        const match = key.match(/^ref_(\d+)_(.+)$/); // Match reference fields with index and property name
        if (match) {
          const index = parseInt(match[1], 10); // Extract index (e.g., 1 or 2)
          const field = match[2]; // Extract field name (e.g., client_name, project_title)

          if (!references[index]) {
            references[index] = {};
          }

          // Map form control values to the appropriate field
          references[index][field] = value;
        }
      }
    });

    // Append each reference object to FormData in the desired API format
    references.forEach((reference, index) => {
      Object.keys(reference).forEach((key) => {
        dataToSubmit.append(`references[${index - 1}][${key}]`, reference[key]);
      });
    });

    return dataToSubmit;
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      const dataToSubmit = this.prepareDataToSubmit();
      this.projectsService.projectPQQResponseStep8(dataToSubmit).subscribe({
        next: () => {
          this.toast.success('Pre Qualification submitted', 'SUCCESS');
          this.ApplicantPqqSectionsComponent.nextStep();
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    } else {
      this.toast.warning(this.message.INVALID_FORMAT, 'WARNING');
      this.formGroup.markAllAsTouched(); // Highlights all invalid fields
    }
  }
}
